import Image from 'next/image'
import { ThumborLoader } from '../../util/thumborLoader'
import type { ImageProps } from 'next/image'

type GImageProps = ImageProps & {
  alt: string
}

const GImage = ({ alt, src, ...rest }: GImageProps) => {
  return <Image alt={alt} loader={ThumborLoader} src={src} {...rest} />
}

export default GImage
